import React, { useState, useEffect } from "react";
import Tab1Image from "../img/envision/energy/cards/ene2.jpg";
import Tab2Image from "../img/envision/energy/cards/ene3.jpg";
import Tab3Image from "../img/envision/energy/cards/energycyber.jpg";
import Tab4Image from "../img/envision/energy/cards/ene5.jpg";
import Tab5Image from "../img/envision/energy/cards/energyconverstion.jpg";

import Tab6Image from "../img/envision/aerospace/tabsimages/jhkk.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCar, faTruck, faGear, faMicrochip, faSlidersH, faWifi, faCogs, faCloud, faVial, faTablet, faNetworkWired, faDesktop, faLaptop } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
const EnergyPageVerticalTabs = () => {
    const [activeTab, setActiveTab] = useState("tab1");
    const [isAutoPlayActive, setIsAutoPlayActive] = useState(true); // State to manage autoplay

    // const handleTabClick = (tab) => setActiveTab(tab);

    const navigate = useNavigate(); // Initialize navigate

    // const handleKnowMoreClick = () => {
    //     // Navigate to the documentaerospacepage with the specific hash
    //     navigate("/documnetEnergyPage#documnetEnergyPageone");
    // };

    const handleKnowMoreClick = (tabId) => {
        console.log("Navigating to:", tabId);
        navigate(`/documnetEnergyPage?activeTab=${tabId}#documnetEnergyPageone`);

        setTimeout(() => {
            const targetElement = document.getElementById("documnetEnergyPageone");
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }, 700);
    };
    const [isHovered, setIsHovered] = useState(false);
    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
        setIsAutoPlayActive(false); // Stop auto-play when tab is clicked
    };
    // Autoplay effect to change tabs every 3 seconds (3000ms)
    useEffect(() => {
        let tabInterval;

        if (!isHovered && isAutoPlayActive) {
            tabInterval = setInterval(() => {
                setActiveTab((prevTab) => {
                    const nextTabNum = parseInt(prevTab.replace("tab", "")) % 5 + 1;
                    return `tab${nextTabNum}`;
                });
            }, 3000);
        }

        return () => clearInterval(tabInterval);
    }, [activeTab, isHovered, isAutoPlayActive]);


    const styles = {
        container: {
            fontFamily: "Arial, sans-serif",
            width: "80%",
            margin: "50px auto",
        },
        tabNav: {

            flexDirection: "column",
            borderRight: "1px solid #fff",
            height: "350px",
            overflowY: "auto", // Ensure only vertical scrolling
            scrollbarWidth: "thin", // For Firefox
            scrollbarColor: "#ccc transparent", // For Firefox
            direction: "rtl", // This makes the scrollbar appear on the left side
        },

        tabButton: {
            padding: "15px",
            cursor: "pointer",
            border: "none",
            background: "none",
            fontSize: "16px",
            fontWeight: "bold",
            color: "#555",
            outline: "none",
            transition: "color 0.3s, background-color 0.3s",
            borderRadius: "10px",
            margin: "5px 0",
            backgroundColor: "#f0f0f0",
        },
        activeTabButton: {
            backgroundColor: "rgb(236 115 34)",
            color: "#fff",
        },
        card: {
            // display: "flex",
            alignItems: "center",
            padding: "20px",
            borderRadius: "15px",
            backgroundColor: "#fff",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
            width: "100%",
            marginLeft: "10px",
            cursor: "pointer"
        },
        image: {
            width: "382px",
            height: "274px",
            borderRadius: "10px",
            marginRight: "20px",
        },
        textContent: {
            flex: 1,
            textAlign: "left",
            color: "#333",
            height:"280px"
            
        },
        icon: {
            marginRight: "10px",
            fontSize: "24px",
            color: "#009ca5",
        },
        dotNav: {
            display: "flex",
            justifyContent: "center",
            marginTop: "10px",
        },
        dot: {
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            backgroundColor: "#ccc",
            margin: "0 5px",
            cursor: "pointer",
            transition: "background-color 0.3s",
        },
        activeDot: {
            backgroundColor: "rgb(236 115 34)",
        },
        knowMoreButton: {
            marginTop: "15px",
            padding: "10px 20px",
            backgroundColor: "rgb(236 115 34)",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "16px",
            transition: "background-color 0.3s",
            // marginLeft: "150px"
        },
        knowMoreButtonHover: {
            backgroundColor: "#e68a00",
        },
    };

    return (
        <div>
            <h1 style={{ textAlign: "center" }}>
                <span style={{ color: "rgb(236 115 34)" }}>Regulatory compliance</span> services
            </h1>
            <div style={styles.container} className="tabclass-container-data">
                <div style={styles.tabNav} className="tabdata">
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(activeTab === "tab1" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab1")}
                        onMouseEnter={(e) => {
                            if (activeTab !== "tab1") {
                                e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                                e.currentTarget.style.color = "#fff"; // Change text to white
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (activeTab !== "tab1") {
                                e.currentTarget.style.backgroundColor = ""; // Revert background
                                e.currentTarget.style.color = ""; // Revert text color
                            }
                        }}

                    >
                        Central Electricity Authority (Cyber Security in Power Sector) Regulations, 2024
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(activeTab === "tab2" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab2")}
                        onMouseEnter={(e) => {
                            if (activeTab !== "tab2") {
                                e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                                e.currentTarget.style.color = "#fff"; // Change text to white
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (activeTab !== "tab2") {
                                e.currentTarget.style.backgroundColor = ""; // Revert background
                                e.currentTarget.style.color = ""; // Revert text color
                            }
                        }}

                    >
                        NCIIPC Guidelines for Critical Information Infrastructure (CII) Protection
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(activeTab === "tab3" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab3")}
                        onMouseEnter={(e) => {
                            if (activeTab !== "tab3") {
                                e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                                e.currentTarget.style.color = "#fff"; // Change text to white
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (activeTab !== "tab3") {
                                e.currentTarget.style.backgroundColor = ""; // Revert background
                                e.currentTarget.style.color = ""; // Revert text color
                            }
                        }}

                    >
                        CERT-In Cybersecurity Directions, 2022
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(activeTab === "tab4" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab4")}
                        onMouseEnter={(e) => {
                            if (activeTab !== "tab4") {
                                e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                                e.currentTarget.style.color = "#fff"; // Change text to white
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (activeTab !== "tab4") {
                                e.currentTarget.style.backgroundColor = ""; // Revert background
                                e.currentTarget.style.color = ""; // Revert text color
                            }
                        }}

                    >
                        Energy Conservation Act, 2001 – Cyber Compliance for Power Sector
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(activeTab === "tab5" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab5")}
                        onMouseEnter={(e) => {
                            if (activeTab !== "tab5") {
                                e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                                e.currentTarget.style.color = "#fff"; // Change text to white
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (activeTab !== "tab5") {
                                e.currentTarget.style.backgroundColor = ""; // Revert background
                                e.currentTarget.style.color = ""; // Revert text color
                            }
                        }}

                    >
                        Smart Grid Cybersecurity Guidelines (ISGF)
                    </button>


                </div>

                <div style={styles.card} className="card-data-vertica-tabs" onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}>
                    <img
                        src={{ tab1: Tab1Image, tab2: Tab2Image, tab3: Tab3Image, tab4: Tab4Image, tab5: Tab5Image, }[activeTab]}
                        alt="Healthcare"
                        style={styles.image}
                        className="tab-image-data"
                    />
                    <div style={styles.textContent}>
                        {(() => {
                            const tabIndex = parseInt(activeTab.replace("tab", "")) - 1;
                            const contentArray = [
                                [
                                    "Development and enforcement of Cybersecurity Policies.",
                                    "Implementation of Access Control, Network Segmentation, and Threat Detection Mechanisms.",
                                    "Establishment of Cyber Security Incident Response Teams (CSIRT).",
                                    "Regular Security Risk Assessments and compliance reporting.",

                                ],
                                [
                                    "Identification & Protection critical assets in IT & OT environments.",
                                    "Red Teaming, Vulnerability Assessments, & Penetration Testing.",
                                    "Established Incident Response & Recovery Mechanisms.",
                                    "Implemented Cybersecurity Risk Management Frameworks",

                                ],
                                [
                                    "Reporting of cyber incidents to CERT-In within 6 hours.",
                                    "IT & OT logs maintenance for a minimum of 180 days.",
                                    "Multi-Factor Authentication (MFA) & Secure Remote Access Controls implemented",
                                    "Regular Cybersecurity Audits & Risk Assessments conducted",
                                ],
                                [
                                    "Secure Energy Management & Monitoring Systems (EMMS).",
                                    "Implemented Access Controls & Cybersecurity Policies for automation networks.",
                                    "Regular Security Assessments for Smart Meters & Grid Systems.",
                                    "Regular Cybersecurity Audits & Risk Assessments conducted",
                                ],
                                [
                                    "Implemented Encryption & Secure Communication Protocols.",
                                    "Regular SCADA/ICS/IIoT Network Vulnerability Assessments.",
                                    "Ensure Third-Party Vendor Compliance & Security Audits.",
                                ],
                            ];

                            // Ensure the selected content is within range and not undefined
                            const selectedContent = contentArray[tabIndex] || [];

                            return selectedContent.map((point, index) => (
                                <ul key={index}>
                                    <li>{point}</li>
                                </ul>
                            ));
                        })()}

                        {/* <button
                            style={{ ...styles.knowMoreButton, ...(window.innerWidth <= 768 ? styles.mobileKnowMoreButton : {}) }}
                            onClick={handleKnowMoreClick}
                            className="know-more-btn"
                        >
                            Know More
                        </button> */}
                        {Array.from({ length: 5 }, (_, index) => {
                            const tabId = `tab${index + 1}`;
                            return (
                                activeTab === tabId && (
                                    <button key={tabId} onClick={() => handleKnowMoreClick(tabId)}
                                        style={{ ...styles.knowMoreButton, ...(window.innerWidth <= 768 ? styles.mobileKnowMoreButton : {}) }}
                                        className="know-more-btn"
                                    >
                                        Know More
                                    </button>
                                )
                            );
                        })}
                    </div>
                </div>
            </div>

            {/* Dot Navigation */}
            <div style={styles.dotNav}>
                {[...Array(5)].map((_, index) => {
                    const tab = `tab${index + 1}`;
                    return (
                        <div
                            key={tab}
                            style={{
                                ...styles.dot,
                                ...(activeTab === tab ? styles.activeDot : {}),
                            }}
                            onClick={() => handleTabClick(tab)}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default EnergyPageVerticalTabs;
